import { Col, Row } from "antd"
import { ApiMultiSelect } from "components/Selects"
import { useMemo } from "react"
import { Uuid } from "types"
import { LinkingDetailItem } from "./NamingSelect"

export default function NamingSelectSeries({
    attributes,
}: {
    activeGroupId: Uuid
    attributes: LinkingDetailItem[]
}) {
    const forNamingAttributes = useMemo(() => {
        return attributes.filter((el) => el.forNaming && el.sortNaming)
    }, [attributes])

    const { namingDefaults } = useMemo(
        () => ({
            namingDefaults: forNamingAttributes
                .filter((v) => v.forNaming && v.sortNaming)
                .sort((a, b) => a.sortNaming - b.sortNaming)
                .map((v) => ({
                    value: v.id,
                    label: v.attribute.name,
                    sort: v.sortNaming,
                })),
        }),

        [forNamingAttributes]
    )

    return (
        <Row gutter={[15, 10]} style={{ marginBottom: 10 }}>
            <Col span={24}>
                <Row gutter={[15, 0]}>
                    <Col md={24} xl={6}>
                        Пользовательское
                    </Col>
                    <Col md={24} xl={18}>
                        <ApiMultiSelect
                            defaultValue={namingDefaults}
                            options={attributes.map(({ attribute, id }) => ({
                                value: id,
                                label: attribute.name,
                                sort: attribute.sort,
                            }))}
                            urls={{
                                addMethod: "post",
                                add: () => `v1/series/links/naming`,
                                remove: () => `v1/series/links/naming`,
                                getAddParams(list) {
                                    return list.reduce((acc, next, i) => {
                                        return {
                                            ...acc,
                                            [next.value]: i + 1,
                                        }
                                    }, {} as Record<Uuid, number | null>)
                                },
                                getRemoveParams(list, prop) {
                                    if (!list.length) {
                                        return {
                                            [prop.removedValue!.value]: null,
                                        }
                                    }
                                    return list.reduce((acc, next, i) => {
                                        return {
                                            ...acc,
                                            [next.value]: i + 1,
                                            [prop.removedValue!.value]: null,
                                        }
                                    }, {} as Record<Uuid, number | null>)
                                },
                                remodeMethod: "post",
                            }}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}
